import React from "react";
import { AiOutlineCalendar } from "react-icons/ai";
import { ImageTag } from "../store/products/ImageTag";

interface Props {
  top?: string;
  left?: string;
}

export const EventTag: React.FC<Props> = ({ top = "0", left = "0" }) => (
  <ImageTag top={top} left={left}>
    <AiOutlineCalendar size="30px" />
  </ImageTag>
);
